import angular from 'angular';
import template from './template.html';
import './style.scss';

export class CurrentJobLabel {

}

export const CurrentJobLabelConfiguration = {
    template,
    bindings: {
        currentJob: '<'
    },
    controller: CurrentJobLabel,
    controllerAs: 'currentJobLabelCtrl'
};

angular
    .module('TALENYA-FE')
    .component('currentJobLabel', CurrentJobLabelConfiguration);
